import { useId } from 'react'

export function useUniqueDef() {
  // use useId to fix hydration error
  const id = `ref-${useId()}`.replace('.', '')
  const url = `url(#${id})`
  return { id, url }
}
